<ips-search
    [suggestions]="results"
    field="party.displayName"
    label="Search Provider"
    inputId="contact-search"
    [placeholder]="'Enter provider name e.g. Heartland Family Practice'"
    [layout]="'row'"
    [maxLength]="100"
    [panelStyleClass]="'contact-search-panel'"
    (search)="search($event)"
    (selectResult)="onSelectionChange($event)">
    
    <ng-template #headerTemplate>
        <div class="contact-search-header">
            <div class="contact-search-col">Facility Name</div>
            <div class="contact-search-col">Address</div>
            <div class="contact-search-col">Contact</div>
        </div>
    </ng-template>

    <ng-template #itemTemplate let-contact>
        <div class="contact-search-row">
            <div class="contact-search-col">{{ contact.party?.displayName }}</div>
            <div class="contact-search-col">{{ getContactAddress(contact) }}</div>
            <div class="contact-search-col">{{ getContactPhone(contact) }}</div>
        </div>
    </ng-template>

    <ng-template #footerTemplate>
        <div class="contact-search-footer">
            <div class="footer-actions" *ngIf="hasMore">
                <span 
                    class="load-more-link" 
                    (click)="loadMore()"
                    [class.disabled]="isLoadingMore">
                    <span *ngIf="!isLoadingMore">Load More</span>
                    <span *ngIf="isLoadingMore">
                        <i class="pi pi-spin pi-spinner"></i> Loading...
                    </span>
                </span>
            </div>
            <div class="footer-content">
                <i class="pi pi-info-circle"></i>
                <span>If you are unable to locate the desired match, please enter the information manually.</span>
            </div>
        </div>
    </ng-template>
</ips-search>
